(() => {
  if (window.sbCartReminderLoaded) return;
  window.sbCartReminderLoaded = true;
  const selector = '#cart-icon-bubble, .header__icon--cart, a[href$="/cart"], a[href$="/cart/"], button[aria-label="Cart"], button[aria-label="Open cart"]';
  let count = null;
  let timer;
  let pending = false;
  let again = false;
  let tabSnapshot = null;
  let tabCount = null;
  let tabAnimation = null;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  function updateTab() {
    const active = document.hidden && count > 0;
    if (!active) {
      clearInterval(tabAnimation);
      tabAnimation = null;
      if (!tabSnapshot) return;
      document.title = tabSnapshot.title;
      for (const icon of tabSnapshot.icons) {
        if (icon.href === null) icon.element.removeAttribute('href');
        else icon.element.setAttribute('href', icon.href);
        if (icon.type === null) icon.element.removeAttribute('type');
        else icon.element.setAttribute('type', icon.type);
      }
      tabSnapshot.extra.remove();
      tabSnapshot = null;
      tabCount = null;
      return;
    }
    if (!tabSnapshot) {
      const extra = document.createElement('link');
      extra.rel = 'icon';
      extra.type = 'image/png';
      extra.sizes = '32x32';
      tabSnapshot = {
        title: document.title,
        icons: [...document.querySelectorAll('link[rel~="icon"]')].map(element => ({
          element, href: element.getAttribute('href'), type: element.getAttribute('type')
        })),
        extra
      };
      document.head.appendChild(extra);
    }
    if (tabCount === count) return;
    tabCount = count;
    clearInterval(tabAnimation);
    tabAnimation = null;
    document.title = `(${count}) ${count === 1 ? 'Item' : 'Items'} in your cart | SoleBrace`;
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 32;
    const context = canvas.getContext('2d');
    if (!context) return;
    const frames = [0, 0.5, 1, 0.5].map(phase => {
      context.clearRect(0, 0, 32, 32);
      context.fillStyle = `rgba(249, 99, 2, ${0.5 - phase * 0.3})`;
      context.beginPath();
      context.arc(16, 16, 12 + phase * 4, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#F96302';
      context.beginPath();
      context.arc(16, 16, 12, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#FFFFFF';
      context.font = `700 ${count > 99 ? 11 : count > 9 ? 15 : 19}px Arial, sans-serif`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText(count > 99 ? '99+' : String(count), 16, 17);
      return canvas.toDataURL('image/png');
    });
    let frame = 0;
    function drawFrame() {
      if (!tabSnapshot) return;
      const image = frames[frame++ % frames.length];
      for (const icon of tabSnapshot.icons) {
        icon.element.href = image;
        icon.element.type = 'image/png';
      }
      tabSnapshot.extra.href = image;
    }
    drawFrame();
    // Background tabs throttle timers; a gentle 1-second cadence avoids busy work.
    if (!reducedMotion.matches) tabAnimation = setInterval(drawFrame, 1000);
  }
  function icons() {
    return [...document.querySelectorAll(selector)].filter(el =>
      el.querySelector('svg, img, .icon-cart') && !el.closest('cart-drawer, #CartDrawer, #upCart')
    );
  }
  function paint() {
    updateTab();
    for (const el of icons()) {
      const active = count > 0;
      if (el.classList.contains('sb-cart-reminder-target') !== active) el.classList.toggle('sb-cart-reminder-target', active);
      for (const badge of el.querySelectorAll('.cart-count-bubble, [class*="__cart-count"]')) {
        if (badge.classList.contains('sb-cart-reminder-badge') !== active) badge.classList.toggle('sb-cart-reminder-badge', active);
      }
    }
  }
  async function refresh() {
    if (!icons().length) return;
    if (pending) { again = true; return; }
    pending = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (Number.isFinite(cart.item_count)) { count = cart.item_count; paint(); }
    } catch (_) { /* Preserve the last confirmed cart state on transient errors. */ }
    finally { pending = false; if (again) { again = false; schedule(); } }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 150); }
  function start() {
    paint();
    refresh();
    // Watch actual cart requests without wrapping fetch/XHR or replacing app callbacks.
    if ('PerformanceObserver' in window) {
      new PerformanceObserver(list => {
        if (list.getEntries().some(entry => /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(entry.name))) schedule();
      }).observe({ type: 'resource', buffered: false });
    }
    new MutationObserver(records => {
      if (records.some(record => record.target.closest?.(selector) || [...record.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches?.(selector) || node.querySelector?.(selector))))) {
        paint();
        if (count === null) schedule();
      }
    }).observe(document.body, { childList: true, subtree: true });
    for (const event of ['cart:updated', 'cart:change', 'cart:refresh', 'shopify:section:load']) document.addEventListener(event, schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('focus', schedule);
    document.addEventListener('visibilitychange', () => { updateTab(); schedule(); });
    reducedMotion.addEventListener('change', () => { tabCount = null; updateTab(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
